import { useSyncExternalStore } from "react";

/**
 * KEY-814: how the Help drawer re-opens the welcome page of the dial on screen. The dial page registers an opener
 * while it shows a dial whose welcome this person may see, and clears it on the way out; the drawer offers
 * "Getting started with this dial" only while one is set. A tiny module store rather than a context so the help
 * chrome, mounted far above the dial page, needs no new provider.
 */
type Opener = { open: () => void; dialName: string } | null;

let current: Opener = null;
const listeners = new Set<() => void>();

export function setWelcomeOpener(next: Opener): void {
  current = next;
  listeners.forEach((l) => l());
}

export function useWelcomeOpener(): Opener {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
    () => null,
  );
}
